import React, { useEffect, useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { AiOutlineInfoCircle, AiOutlineWarning } from "react-icons/ai";
import TimeSpentConfirmationModal from "./TimeSpentConfirmationModal";

const ConfirmationModal = ({
  show,
  sendTo,
  messageType,
  jobServiceRowId,
  jobNo,
  jobTitle,
  resetState,
  title,
  children,
  danger,
  autoInvoiceContactInfo,
}) => {
  const [showTimeSpentModal, setShowTimeSpentModal] = useState(false);
  const [showAlert, setShowAlert] = useState(false);

  const hasEmailIssue = autoInvoiceContactInfo?.has_email_issue || autoInvoiceContactInfo?.hasEmailIssue;
  const effectiveDanger = danger && !hasEmailIssue;

  useEffect(() => {
    if (show) {
      setShowAlert(true);
    } else {
      setShowAlert(false);
      setShowTimeSpentModal(false);
    }
  }, [show]);

  const customIcon = (
    <div>
      {effectiveDanger ? (
        <AiOutlineWarning
          style={{
            fontSize: "80px",
            color: "#dc3545",
            margin: "20px auto",
          }} />
      ) : (
        <AiOutlineInfoCircle
          style={{
            fontSize: "80px",
            color: "rgb(70, 184, 218)",
            margin: "20px auto",
          }} />
      )}
    </div>
  );

  const dangerTitle = (
    <span style={{ fontSize: "18px", fontWeight: "normal" }}>
      Are you sure this Job is Ready to Send? This will generate an invoice and authorise the Job to be sent the Client
    </span>
  );

  const alertTitle = effectiveDanger ? dangerTitle : (title || (
    <span style={{ fontSize: "18px", fontWeight: "normal" }}>
      Are you sure you have finalized your work on
      {" "}
      <b>{`${jobNo} - ${jobTitle}`}</b>
      {" "}
      and wish to send to
      {" "}
      <b>{messageType}</b>
      ?
    </span>
  ));

  const handleMainConfirm = () => {
    setShowAlert(false);
    setShowTimeSpentModal(true);
  };

  const handleCancel = () => {
    setShowTimeSpentModal(false);
    resetState();
  };

  const handleTimeSpentConfirm = () => {
    setShowTimeSpentModal(false);
    const options = hasEmailIssue ? { skip_auto_invoice: true } : {};
    sendTo(options);
    resetState();
  };

  const useCustomMode = effectiveDanger || !title;

  return (
    <>
      {showAlert && (
        <SweetAlert
          custom={useCustomMode ? true : undefined}
          showCancel
          showCloseButton
          show={showAlert}
          type={useCustomMode ? undefined : "info"}
          title={alertTitle}
          closeOnClickOutside
          allowEscape={false}
          cancelBtnBsStyle="light"
          confirmBtnText="Send"
          confirmBtnCssClass={effectiveDanger ? "btn btn-danger" : undefined}
          confirmBtnStyle={effectiveDanger ? { border: "none", boxShadow: "none" } : undefined}
          customIcon={useCustomMode ? customIcon : undefined}
          onCancel={resetState}
          onConfirm={handleMainConfirm}>
          {children}
        </SweetAlert>
      )}

      <TimeSpentConfirmationModal
        jobServiceRowId={jobServiceRowId}
        show={showTimeSpentModal}
        resetState={handleCancel}
        sendTo={handleTimeSpentConfirm} />
    </>
  );
};

export default ConfirmationModal;
